// extracted by mini-css-extract-plugin
export var text = "_4s-0";